// extracted by mini-css-extract-plugin
export var container = "_6g-0";
export var fallback = "_6g-5";
export var fallbackIcon = "_6g-6";
export var hidden = "_6g-2";
export var image = "_6g-3";
export var loaded = "_6g-4";
export var placeholder = "_6g-1";